import axios from "axios";

const api = axios.create({
  baseURL: "https://api.monkeye.in/api",
  withCredentials: true, // Important: send cookies
});

// const api = axios.create({
//   baseURL: "http://localhost:5000/api",
//   withCredentials: true, // Important: send cookies
// });

// Request interceptor - add access token to headers
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || localStorage.getItem("accessToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Response interceptor - handle token refresh on 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If we get a 401 and haven't already retried
    if (error.response?.status === 401 && !originalRequest._retry) {
      const errorData = error.response?.data;

      // Refresh when access token expired OR when there's no token locally but a refresh cookie may exist
      const shouldAttemptRefresh =
        errorData?.code === "TOKEN_EXPIRED" ||
        errorData?.code === "TOKEN_INVALID" ||
        (errorData?.code === "NO_TOKEN" && !(localStorage.getItem("token") || localStorage.getItem("accessToken"))) ||
        errorData?.message?.toLowerCase()?.includes("expired");

      if (shouldAttemptRefresh) {
        originalRequest._retry = true;

        // Coalesce concurrent refresh requests
        if (!api._isRefreshing) api._isRefreshing = false;
        if (!api._refreshSubscribers) api._refreshSubscribers = [];

        const subscribeToken = (cb) => api._refreshSubscribers.push(cb);
        const onRefreshed = (token) => {
          api._refreshSubscribers.forEach((cb) => cb(token));
          api._refreshSubscribers = [];
        };

        try {
          if (api._isRefreshing) {
            // Wait for the in-flight refresh to complete, then retry
            return new Promise((resolve, reject) => {
              subscribeToken((newToken) => {
                if (!newToken) return reject(new Error("Failed to refresh token"));
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                resolve(api(originalRequest));
              });
            });
          }

          api._isRefreshing = true;

          const refreshResponse = await api.post(
            "/auth/refresh-token",
            {},
            { withCredentials: true }
          );

          if (refreshResponse.data?.success) {
            const newToken = refreshResponse.data?.token;
            if (newToken) {
              localStorage.setItem("token", newToken);
              localStorage.removeItem("accessToken");

              onRefreshed(newToken);
              api._isRefreshing = false;

              originalRequest.headers.Authorization = `Bearer ${newToken}`;
              return api(originalRequest);
            }
          }

          // If refresh did not return a token, treat as failure
          onRefreshed(null);
          api._isRefreshing = false;
          localStorage.removeItem("token");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("user");
          localStorage.removeItem("vendorProfile");
          localStorage.removeItem("agentProfile");
          window.location.href = "/login";
          return Promise.reject(new Error("Refresh failed"));
        } catch (refreshError) {
          onRefreshed(null);
          api._isRefreshing = false;
          localStorage.removeItem("token");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("user");
          localStorage.removeItem("vendorProfile");
          localStorage.removeItem("agentProfile");
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
